import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const FAQLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <section>
      <UIHeading1 as="h2" color="text-primary-default">
        Вопросы и ответы
      </UIHeading1>

      <div className={styles['wrapper']}>{children}</div>
    </section>
  );
};
